<template>
  <div class="relative h-full w-full">
    <div
      class="animate-rotate absolute top-1/2 left-1/2 flex w-2/3 -translate-x-1/2 -translate-y-1/2"
    >
      <div
        class="animate-bouncy-spin absolute top-1/2 left-1/2 aspect-square w-full -translate-x-1/2 -translate-y-1/2"
      >
        <BaseWavyCircle
          :animated="true"
          :thickness="6"
          :wavelength="8"
          :amplitude="1.2"
          :percentage="percentage * 100"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseWavyCircle from './BaseWavyCircle.vue'

  import { useFixedSequence } from '@/core/composables/use-fixed-sequence'
  import { onMounted } from 'vue'

  const sequence = [
    { value: 0.2, delay: 2000 },
    { value: 0.7, delay: 2000 },
  ]
  const { value: percentage, start } = useFixedSequence(sequence)

  onMounted(() => {
    start()
  })
</script>
